import '../styles/App.css';

import React from 'react';

import InputSlider from './InputSlider'
import InputRadioButtons from './InputRadioButtons'
import InputDropDown from './InputDropDown'

import _ from 'lodash';

class InputForm extends React.Component {

    // In state: define tab selection. 
    render() {
        const selected_sex = this.props.data.find(item => item.feature_ukb === 'Genetic sex_0.0');
        // console.log('Selected sex: ', selected_sex);

        let filteredData = this.props.data;

        const hasSexSpecificFeatures = this.props.data.some(item => 
            'features_women' in item && 'features_men' in item
        );

        if (hasSexSpecificFeatures && selected_sex) {
            const sexValue = parseInt(selected_sex.inputValue);
            if (sexValue === 1) { // Male
                filteredData = this.props.data.filter(item => 
                    parseInt(item.features_men) === 1
                );
            } else if (sexValue === 0) { // Female
                filteredData = this.props.data.filter(item => 
                    parseInt(item.features_women) === 1
                );
            } else {
                filteredData = this.props.data.filter(item => item.feature_ukb === 'Genetic sex_0.0')
            }
        }

        var formList = _.map(filteredData, function(item){
            //if type is binary, return switch. If type is numeric, slider. 
            var extraInfo = item.extra_info

            if (item.type === 'numeric'){ 
                var formComponent = <InputSlider 
                    // key={item.name} 
                    name={item.name} 
                    labels={item.values_text} 
                    values={item.values_numeric} 
                    startValue={(item.inputValue == null) ? '' : item.inputValue} 
                    handleClick={this.props.handleClick} 
                    unit={item.unit} 
                    extraInfo={extraInfo}
                />
            } else if (item.type === 'binary'){
                var formComponent = <InputRadioButtons
                    // key={item.name}
                    name={item.name}
                    labels={item.values_text}
                    values={item.values_numeric}
                    startValue={(item.inputValue == null) ? '' : item.inputValue}
                    handleClick={this.props.handleClick} extraInfo={extraInfo} 
                />
            } else if (item.type === 'categorical'){
                var formComponent = <InputDropDown
                    // key={item.name}
                    name={item.name}
                    labels={item.values_text}
                    values={item.values_numeric}
                    startValue={(item.inputValue == null) ? '' : item.inputValue}
                    handleClick={this.props.handleClick}
                    extraInfo={extraInfo} 
                />
            }

            return(<div key={item.name} className='form-row'>
                        <div className='form-item'>
                            {formComponent}
                        </div>
                    </div>
            )
        }.bind(this))

        return(
            <div className='input-form'>
               {formList}
            </div>
        )
    }
}

export default InputForm;
